module.exports = __webpack_public_path__ + "static/img/theme_04.5fac7457.png";